/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { provideSvgIconsConfig, SvgIconComponent } from '@ngneat/svg-icon';

import { faQuestionSquareIcon } from 'IconLibrary/fontawesome/regular/question-square';
import { faCalendarAltIcon } from 'IconLibrary/fontawesome/regular/calendar-alt';
import { faDownloadIcon } from 'IconLibrary/fontawesome/regular/download';
import { faEllipsisHIcon } from 'IconLibrary/fontawesome/regular/ellipsis-h';
import { faLinkIcon } from 'IconLibrary/fontawesome/regular/link';
import { faPlusIcon } from 'IconLibrary/fontawesome/regular/plus';
import { faRedoIcon } from 'IconLibrary/fontawesome/regular/redo';
import { faCheckIcon } from 'IconLibrary/fontawesome/regular/check';
import { faChevronDownIcon } from 'IconLibrary/fontawesome/regular/chevron-down';
import { faChevronUpIcon } from 'IconLibrary/fontawesome/regular/chevron-up';
import { faClockIcon } from 'IconLibrary/fontawesome/regular/clock';
import { faCloudUploadIcon } from 'IconLibrary/fontawesome/regular/cloud-upload';
import { faCopyIcon } from 'IconLibrary/fontawesome/regular/copy';
import { faFileAltIcon } from 'IconLibrary/fontawesome/regular/file-alt';
import { faUserIcon } from 'IconLibrary/fontawesome/regular/user';
import { fasExclamationTriangleIcon } from 'IconLibrary/fontawesome/solid/exclamation-triangle';
import { fasCommentExclamationIcon } from 'IconLibrary/fontawesome/solid/comment-exclamation';
import { faTimesIcon } from 'IconLibrary/fontawesome/regular/times';
import { faLevelUpIcon } from 'IconLibrary/fontawesome/regular/level-up';
import { faUnsplashIcon } from 'IconLibrary/fontawesome/brands/unsplash';
import { bulbArrowUpShortWideSolidIcon } from 'IconLibrary/bulb/arrow-up-short-wide-solid';
import { bulbArrowUpWideShortSolidIcon } from 'IconLibrary/bulb/arrow-up-wide-short-solid';
import { bulbAssignTripleArrowIcon } from 'IconLibrary/bulb/assign_triple_arrow';
import { bulbBulbCollectionIcon } from 'IconLibrary/bulb/bulb_collection';
import { bulbGoogleClassroomIcon } from 'IconLibrary/bulb/google-classroom';
import { bulbMakeChangesVisibleIcon } from 'IconLibrary/bulb/make_changes_visible';
import { bulbBPlusIconIcon } from 'IconLibrary/bulb/b-plus-icon';
import { bulbThreeArrowsIcon } from 'IconLibrary/bulb/three-arrows';
import { bulbThumbtackSlashIcon } from 'IconLibrary/bulb/thumbtack-slash';
import { bulbCirclePlusSolidIcon } from 'IconLibrary/bulb/circle-plus-solid';
import { fasMinusHexagonIcon } from 'IconLibrary/fontawesome/solid/minus-hexagon';
import { fasDoorOpenIcon } from 'IconLibrary/fontawesome/solid/door-open';
import { faLockAltIcon } from 'IconLibrary/fontawesome/regular/lock-alt';
import { fasThumbsUpIcon } from 'IconLibrary/fontawesome/solid/thumbs-up';

import { faPaperPlaneIcon } from 'IconLibrary/fontawesome/regular/paper-plane';
import { faSchoolIcon } from 'IconLibrary/fontawesome/regular/school';
import { faUserTieIcon } from 'IconLibrary/fontawesome/regular/user-tie';
import { AllIconsComponent } from './all-icons/all-icons.component';

/**
 * Exported icons for use in storybook stories.
 */
export const icons = [
  // Bulb Icons
  bulbBulbCollectionIcon,
  bulbGoogleClassroomIcon,
  bulbMakeChangesVisibleIcon,
  bulbAssignTripleArrowIcon,
  bulbArrowUpShortWideSolidIcon,
  bulbArrowUpWideShortSolidIcon,
  bulbThreeArrowsIcon,
  bulbBPlusIconIcon,
  bulbCirclePlusSolidIcon,
  bulbThumbtackSlashIcon,

  // FontAwesome Icons
  faCalendarAltIcon,
  faDownloadIcon,
  faEllipsisHIcon,
  faLinkIcon,
  faPlusIcon,
  faRedoIcon,
  faPaperPlaneIcon,
  faSchoolIcon,
  fasExclamationTriangleIcon,
  fasCommentExclamationIcon,
  faTimesIcon,
  faLevelUpIcon,
  faUnsplashIcon,
  fasMinusHexagonIcon,
  fasDoorOpenIcon,
  faLockAltIcon,
  fasThumbsUpIcon,
  faCheckIcon,
  faChevronDownIcon,
  faChevronUpIcon,
  faClockIcon,
  faCloudUploadIcon,
  faCopyIcon,
  faFileAltIcon,
  faUserIcon,
  faUserTieIcon,
];

@NgModule({
  declarations: [
    AllIconsComponent,
  ],
  imports: [
    CommonModule,
    SvgIconComponent,
  ],
  exports: [
    AllIconsComponent,
    SvgIconComponent,
  ],
  providers: [
    provideSvgIconsConfig({
      icons,
      missingIconFallback: faQuestionSquareIcon,
    }),
  ],
})
export class SVGIconModule { }
